export async function insertHtmlContent(htmlString: string): Promise<void> {
	try {
		await Word.run(async context => {
			// Get the current selection
			const selection = context.document.getSelection();

			// Insert the HTML at the current selection
			// Word will interpret the HTML tags (p, h1, ul, ol, li, etc.)
			// and apply corresponding formatting or styles
			selection.insertHtml(htmlString, Word.InsertLocation.replace);

			// Synchronize the document state.
			// This executes the queued commands (like insertHtml).
			await context.sync();
		});
	} catch (error) {
		console.error('Error inserting HTML content: ', error);
		// You might want to display this error to the user in the add-in UI
		if (error instanceof OfficeExtension.Error) {
			console.error('Debug info: ' + JSON.stringify(error.debugInfo));
		}
	}
}

export async function copyHtmlContent(): Promise<string | undefined> {
	try {
		return await Word.run(async context => {
			const body = context.document.body;

			// Get the HTML content
			const htmlContent = body.getHtml();

			// Synchronize the document state
			await context.sync();

			// Now we can safely access the value
			return htmlContent.value;
		});
	} catch (error) {
		console.error('Error copying HTML content: ', error);

		if (error instanceof OfficeExtension.Error) {
			console.error('Debug info: ' + JSON.stringify(error.debugInfo));
		}

		return undefined;
	}
}

export async function getSelection(): Promise<string | undefined> {
	try {
		return await Word.run(async context => {
			// Get the current selection
			const selection = context.document.getSelection();

			// Get the HTML content of the selection
			const htmlContent = selection.getHtml();

			// Synchronize the document state
			await context.sync();

			// Return the selected HTML content
			return htmlContent.value;
		});
	} catch (error) {
		console.error('Error getting selection: ', error);

		if (error instanceof OfficeExtension.Error) {
			console.error('Debug info: ' + JSON.stringify(error.debugInfo));
		}

		return undefined;
	}
}
